import { Button, MenuItem, Select, Switch, Typography } from '@mui/material';
import { useState } from 'react';
import DomainApi from '../../api/domains';
import { connect } from 'react-redux';
import { showError, showMessage } from '../../actions/uiActions';

const LAYOUT_TYPES = [
    {
        id: 'folder',
        text: 'Tabbed Layout',
    },
    {
        id: 'page',
        text: 'Single Layout',
    },
];

const Faq = ({ domain, onSaveSuccess, showMessage }) => {

    const [config, setConfig] = useState({
        enabled: domain?.splashPageConfig?.faq?.enabled || false,
        layout: domain?.splashPageConfig?.faq?.layout || 'page',
    })

    const handleSaveFaqConfig = async () => {
        try {
            await DomainApi.updateSplashPage(domain._id, {
                ...domain.splashPageConfig,
                faq: config
            });
            showMessage('Splash page configuration saved successfully.');
            onSaveSuccess(domain._id, { ...domain.splashPageConfig, faq: config });
        } catch (error) {
            showError(error.message || 'An error occurred while saving configuration.');
        }
    };


    return (
        <div>
            <Typography variant="body2" component="div" className='mb-6'>
                Manage FAQ Content at:
                <a href={"https://peoplejoy.atlassian.net/wiki/spaces/SPC/overview?homepageId=3143041282"} target='_blank' rel='noreferrer'> https://peoplejoy.atlassian.net/wiki/spaces/SPC/overview?homepageId=3143041282</a>
            </Typography>
            <div className='flex mt-4 items-center'>
                <Typography variant='subtitle1' sx={{ width: "500px" }} gutterBottom>
                    Enable or disable the Frequently Asked Questions section on your
                    splash page to provide quick answers to common inquiries from your
                    users.
                </Typography>
                <Switch
                    size='medium'
                    color='primary'
                    checked={config.enabled}
                    sx={{ marginLeft: "20px" }}
                    onChange={(e) => setConfig({ ...config, enabled: e.target.checked })}
                />
            </div>
            <div className='mt-4'>
                <Typography variant='body2' color='textSecondary'>
                    Select Layout Type:
                </Typography>

                <Select
                    style={{ minWidth: 300 }}
                    defaultValue={'page'}
                    value={config.layout}
                    onChange={(e) => setConfig({ ...config, layout: e.target.value })}
                    disabled={!config.enabled}
                >
                    {LAYOUT_TYPES.map((opt) => (
                        <MenuItem key={opt.id} value={opt.id}>
                            {opt.text}
                        </MenuItem>
                    ))}
                </Select>
            </div>

            <div className='d-flex justify-content-end mt-4'>
                <Button variant='outlined' onClick={() => window.history.back()}>
                    Cancel
                </Button>
                <Button onClick={handleSaveFaqConfig} variant="contained" sx={{ ml: 2 }}>Save</Button>
            </div>
        </div>
    );
};

export default connect(null, { showError, showMessage })(Faq);
